import { render, staticRenderFns } from "./Strips.vue?vue&type=template&id=46ca323f&"
import script from "./Strips.vue?vue&type=script&lang=js&"
export * from "./Strips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports